export const environmentUrl = 'https://fundme.cash';
//export const environmentUrl = 'http://localhost:3002';